import { useState, useMemo, type ChangeEvent } from 'react'

export const useFilteredData = (tableData, searchKeys: string[]) => {
  const [inputfilterString, setInputFilterString] = useState('')

  const filteredTableData = useMemo(() => (
    tableData?.filter(user => {
      const matchesSearch = !inputfilterString.trim() || searchKeys.some(key => {
        const value = key.split('/').reduce((acc, el) => acc?.[el], user)
        return value?.toLowerCase().includes(inputfilterString.toLowerCase())
      })

      return matchesSearch
    })
  ), [tableData, inputfilterString, searchKeys])

  const handleFilter = (e: ChangeEvent<HTMLInputElement>) => {
    setInputFilterString(e.target.value)
  }

  return {
    filteredTableData,
    handleFilter
  }
}
